import App from '@/models/App'

export default class OrderingOrdererItemTopCategory extends App {
    static get entity() {
        return 'OrderingOrdererItemTopCategories'
    }

    static all() {
        return this.query().get()
    }

    static first() {
        return this.query().first()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingShipId: this.attr(''),
            name: this.attr(''),
            sort: this.attr(''),
            lock: this.attr(false),
        }
    }

    static apiConfig = {
        actions: {
            find(orderingShipId, orderingItemTopCategoryId) {
                return App.api().get(
                    `/ordering/orderer/${orderingShipId}/topCategories/${orderingItemTopCategoryId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            fetch(orderingShipId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/topCategories`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/topCategories`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, itemTopCategoryId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/topCategories/${itemTopCategoryId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            sorting(orderingShipId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/topCategories/sorting`,
                    params,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, itemTopCategoryId) {
                return this.delete(
                    `/ordering/orderer/${orderingShipId}/topCategories/${itemTopCategoryId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: itemTopCategoryId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
